import { MONTH_NAMES, MONTHS_TO_SHOW, shiftMonth } from "../lib/dates";
import { BRAND } from "../lib/brand";

/* ───────────────────── MONTH NAVIGATOR ───────────────────── */
export function MonthNavigator({ startYear, startMonth, onShift, onReset }) {
  const endInfo = shiftMonth(startYear, startMonth, MONTHS_TO_SHOW - 1);
  const label = MONTH_NAMES[startMonth].slice(0, 3) + " " + startYear +
    " – " + MONTH_NAMES[endInfo.month].slice(0, 3) + " " + endInfo.year;
  return (
    <div className="flex items-center justify-center gap-2 mb-4">
      <button onClick={() => onShift(-MONTHS_TO_SHOW)}
        className="p-1.5 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-300 transition-colors" title="Previous 3 months">
        <svg className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 19l-7-7 7-7" />
        </svg>
      </button>
      <button onClick={() => onShift(-1)}
        className="p-1.5 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-300 transition-colors" title="Previous month">
        <svg className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button onClick={onReset}
        className="px-4 py-1.5 text-sm font-semibold rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-300 transition-colors min-w-[180px]" style={{ color: BRAND.accent }}>
        {label}
      </button>
      <button onClick={() => onShift(1)}
        className="p-1.5 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-300 transition-colors" title="Next month">
        <svg className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
      <button onClick={() => onShift(MONTHS_TO_SHOW)}
        className="p-1.5 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-300 transition-colors" title="Next 3 months">
        <svg className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}
